// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"10cd9493","732":"d36023bd","977":"7f6aa5ac"}[chunkId] + ".chunk.js";
};